interface Props {
  color?: string;
}

const CloseIcon: React.FC<Props> = ({ color = "#0D0C21" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.7338 6.27531C17.3788 5.92036 16.8055 5.92036 16.4505 6.27531L12.0001 10.7167L7.54949 6.26621C7.19454 5.91126 6.62116 5.91126 6.26621 6.26621C5.91126 6.62116 5.91126 7.19454 6.26621 7.54948L10.7168 12L6.26621 16.4505C5.91126 16.8055 5.91126 17.3788 6.26621 17.7338C6.62116 18.0887 7.19454 18.0887 7.54949 17.7338L12.0001 13.2833L16.4505 17.7338C16.8055 18.0887 17.3788 18.0887 17.7338 17.7338C18.0887 17.3788 18.0887 16.8055 17.7338 16.4505L13.2833 12L17.7338 7.54948C18.0796 7.20364 18.0796 6.62116 17.7338 6.27531Z"
        fill={color}
      ></path>
    </svg>
  );
};

export default CloseIcon;
